import PropTypes from 'prop-types';
import Head from 'next/head';
import cn from 'classnames';
import { getVideoObjectMicrodata } from 'utils/microdata/videoUtils';
import { useYoutubeVideoMetadata } from 'utils/youtubeVideosContext';
import styles from './styles.module.scss';

export const CustomYoutubePlayer = ({
  src,
  className,
  isArticle,
}) => {
  const videoMeta = useYoutubeVideoMetadata(src);
  const microdata = isArticle
    ? getVideoObjectMicrodata({ ...videoMeta, videoId: src })
    : null;

  return (
    <>
      {microdata && (
        <Head>
          <script
            id={`JSON-LD-video-${src}`}
            key={`JSON-LD-video-${src}`}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
          />
        </Head>
      )}

      <div className={cn(styles.player, className)}>
        <iframe
          width="853"
          height="480"
          src={`https://www.youtube.com/embed/${src}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    </>
  );
};

CustomYoutubePlayer.defaultProps = {
  className: '',
  isArticle: false,
};

CustomYoutubePlayer.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  isArticle: PropTypes.bool,
};
